export const GET_CITYID = "GET_CITYID";
export const GET_USER_LOCATION = "GET_USER_LOCATION";
export const GET_LOCATION_RESTAURANTS = "GET_LOCATION_RESTAURANTS";
export const RESTAURANT_SEARCH = "RESTAURANT_SEARCH";
export const SEARCH_MENUS = "SEARCH_MENUS";
export const RESTAURANT_DETAILS = "RESTAURANT_DETAILS";
